import { Auth } from "aws-amplify";
export async function getRegion() {
    let amplifyId = await Auth.currentUserInfo();
    amplifyId = amplifyId.id;
    let region = amplifyId.split(":")[0];
    return region;
  }